<button matRipple (click)="openEditContentPage()" class="button"
  [title]="'event_content.edit_content_button' | translate">
  {{ 'page.detail.buttons.title_edit' | translate }}
</button>
